import GroupLotto, { GroupLottoItemProps } from '../components/GroupLotto'
import NotificationBanner, {
  NotificationBannerProps,
} from '../components/NotificationBanner'
import SwiperResult, { SwiperResultProps } from '../components/SwiperResult'
import SelectionTabs, { SelectionTabsProps } from '../components/SelectionTabs'
import styles from './HomeScreen.module.css'

interface HomeScreenProps {
  notificationBannerProps: NotificationBannerProps
  swiperResultProps: SwiperResultProps
  selectionTabsProps: SelectionTabsProps
  groupsLotto: GroupLottoItemProps[]
}
export const HomeScreen = ({
  notificationBannerProps,
  swiperResultProps,
  selectionTabsProps,
  groupsLotto,
}: HomeScreenProps) => {
  return (
    <div className={`w-full ${styles.container}`}>
      <div className={`w-full ${styles.bannerWrapper}`}>
        <NotificationBanner {...notificationBannerProps} />
      </div>
      <div className={`w-full ${styles.swiperWrapper}`}>
        <SwiperResult {...swiperResultProps} />
      </div>
      <div className={`mt-8 w-full ${styles.selectionTabsWrapper}`}>
        <SelectionTabs {...selectionTabsProps} />
      </div>
      <div
        className={`flex flex-col gap-4 mt-8 w-full ${styles.lottoGroupsWrapper}`}
      >
        {groupsLotto.map((group) => (
          <GroupLotto key={group.id} {...group} />
        ))}
      </div>
    </div>
  )
}
